var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showcounter),expression:"showcounter"}],attrs:{"id":"levelstage"}},[_c('backgroundFast'),_c('div',{staticClass:"counter",attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.counter))]),_c('h1',{attrs:{"id":"message","role":"status","aria-live":"polite"}},[_vm._v("Pronti")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }